/* eslint-disable react/prop-types */
import React from 'react';
import { PageReady } from '@bingads-webui/page-ready';
import { withPageReadyAsync } from '@bingads-webui-react/with-page-ready';

const DelayedPreexecuteContainer = withPageReadyAsync(() =>
  import(/* webpackMode: 'eager' */'./preexecute-container')
    .then(({ StyledPreexecuteContainer }) => ({
      default: StyledPreexecuteContainer,
    })), null);

export const withPreexecute = (Component, PreexecuteComponents) => (props) => {
  const pageReadyPromise = PageReady.afterPageReady();

  if (!pageReadyPromise.isFulfilled()) {
    return (
      <React.Fragment>
        <Component {...props} />
        <DelayedPreexecuteContainer
          pageName={Component.pageName}
          PreexecuteComponents={PreexecuteComponents}
          {...props}
        />
      </React.Fragment>
    );
  }

  return <Component {...props} />;
};
